import { 
	call, 
	put, 
	takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* notificationsCount(action: ActionInterface): any {
  try {
		let request = "events?first_item=0&last_item=0&event_type_ids=15,16,33&removed=0&reacted=0&is_snoozed=0";
 
    const res = yield call(Http.get, request);

    yield put({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST_SUCCESS,
      payload: {
        notificationsEventsCount: res.data.events.count
      }
    });

    yield put({
      type: Constants.GLOBAL_NOTIFICATIONS_COUNT_SUCCESS
    });
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchNotificationsCount() {
  yield takeEvery(Constants.GLOBAL_NOTIFICATIONS_COUNT, notificationsCount);
}
